const pym = require("./lib/pym");

const MapboxGL = require("mapbox-gl");
const {Map, NavigationControl, Popup} = MapboxGL;
const topojson = require("topojson-client");

const orderData = require("../../data/vacate-orders.json");
const orders = topojson.feature(orderData, orderData.objects['vacate-orders']);

const container = document.querySelector(".map-container .map");

const map = new Map({
  container: container,
  style: "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json",
  fadeDuration: 0
});

map.once("load", async () => {
  map.fitBounds([-74.355772, 40.448137, -73.653333, 40.980042], {
    padding: 20,
    duration: 0
  });

  map.addControl(new NavigationControl({
    showCompass: false
  }), "top-right");

  // Sources

  map.addSource("orders", {
    "type": "geojson",
    "data": orders
  });

  // Layers

  map.addLayer({
    "id": "orders",
    "type": "circle",
    "source": "orders",
    "paint": {
      "circle-color": "#A9328A"
    }
  }, "watername_ocean");

  addPopup(map);
});

function addPopup(map) {
  const popup = new Popup();
  const layer = "orders";
  const boroughCodes = {
    MN: 1,
    BX: 2,
    BK: 3,
    QN: 4,
    SI: 5
  };

  const onMouseMove = (coordinates, props) => {
    const description = `<div class="popup-content">
      <div class="report">
        <h3>Effective date: ${props.DATE}</h3> 
        <p><a href="https://hpdonline.hpdnyc.org/HPDonline/provide_address.aspx?p1=${boroughCodes[props.BOROUGH]}&p2=${props.NUMBER}&p3=${props.STREET.replace(/\s/g, "+")}" target="_parent">Search on HPD Online</a></p>
      </div>
    </div>`;

    popup.setLngLat(coordinates).setHTML(description);
    popup.addTo(map);
  };

  map.on("click", layer, e => {
    const coordinates = e.lngLat;
    const props = e.features[0].properties;

    onMouseMove(coordinates, props);
  });

  map.on("mouseenter", layer, () => {
    map.getCanvas().style.cursor = "pointer";
    // popup.addTo(map);
  });

  map.on("mouseleave", layer, () => {
    map.getCanvas().style.cursor = "";
    /// popup.remove();
  });
}
